import "./App.css";
import Game from "./screens/game/game";

function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
